import React from 'react';
import { Skeleton, Box, Card, CardContent, useTheme, useMediaQuery } from '@mui/material';

export const SpeakUpCommentSkeleton: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card
      sx={{
        borderRadius: 6,
        border: '2px solid #019df2',
        boxShadow: '0 4px 12px rgba(96, 165, 250, 0.15)',
        bgcolor: 'white',
        mx: 'auto',
        width: '100%',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      }}
    >
      <CardContent sx={{ p: { xs: 3, md: 2 } }}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          {/* Left side - Speak up icon and title */}
          <Box display="flex" alignItems="center" gap={2}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #10b981 0%, #3b82f6 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
              }}
            >
              {/* Chat bubble icon skeleton */}
              <Skeleton
                variant="rectangular"
                width={20}
                height={16}
                sx={{
                  borderRadius: 1,
                  bgcolor: 'white',
                  opacity: 0.9,
                }}
              />
              {/* Three dots inside chat bubble */}
              <Box
                sx={{
                  position: 'absolute',
                  display: 'flex',
                  gap: 0.5,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              >
                {[...Array(3)].map((_, i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 3,
                      height: 3,
                      borderRadius: '50%',
                      bgcolor: '#019df2',
                    }}
                  />
                ))}
              </Box>
            </Box>
            <Skeleton variant="text" width={90} height={28} />
          </Box>

          {/* Right side - Overall button */}
          <Skeleton
            variant="rounded"
            width={80}
            height={16}
            sx={{
              bgcolor: '#019df2',
            }}
          />
        </Box>

        {/* Comment Date */}
        <Box mb={1}>
          <Skeleton variant="text" width={200} height={24} sx={{ mb: 1 }} />
        </Box>

        {/* Comment Content */}
        <Box mb={2}>
          <Skeleton variant="text" width={80} height={18} sx={{ mb: 2 }} />
        </Box>

        {/* Status Card */}
        <Card
          sx={{
            borderRadius: 2,
            border: '1px solid #e5e7eb',
            bgcolor: '#f9fafb',
            mb: 2,
          }}
        >
          <CardContent sx={{ p: 2 }}>
            {/* Status Title */}
            <Skeleton variant="text" width={160} height={24} sx={{ mb: 1 }} />

            {/* Status Description */}
            <Skeleton variant="text" width="85%" height={18} />
          </CardContent>
        </Card>

        {/* Action Button */}
        <Box display="flex" justifyContent="center">
          <Skeleton
            variant="rectangular"
            width={160}
            height={48}
            sx={{
              borderRadius: 8,
              bgcolor: '#0072b0',
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};
